import { Pipe, PipeTransform } from '@angular/core';
import { formatField } from '@23degrees/shared-code/utilities/format';

@Pipe({
    name: 'format',
    pure: true,
    standalone: true,
})
export class FormatPipe implements PipeTransform {

  public transform = (obj: any, fieldFormat?: any, addPreSuffix: boolean = true, inputLocale: string = 'de-DE'): any => {
    return formatField(obj, fieldFormat, addPreSuffix, inputLocale);
  };
}
